function sortCampaigns(a, b) {
  if (a.isPriority !== b.isPriority) {
    return a.isPriority ? -1 : 1;
  }
  return a.title?.localeCompare(b.title);
}

// eslint-disable-next-line import/prefer-default-export
export { sortCampaigns };
